import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { path } from 'router/sections';
import { TableExt, TableInfo, GridBox } from 'libs/ui';
import { getTableParams } from './grid.params';

export const CallsGrid = (props) => {
  const { count, entries, className, theme } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const [row, setRow] = useState({});

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  /**
   * go to park session card
   * @param {*} row
   */
  const showParkingCardAction = (row) => {
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  /**
   * go to subscription with filter
   * @param {*} row
   */
  const showSubscriptionAction = (row) => {
    history.push(path('subscription'), {
      filter: {
        mean_id: row.mean_id,
      },
    });
  };

  /**
   * toggle qr window
   */
  const showQrWindow = () => {
    setShowQr((val) => !val);
  };

  // actions
  const actions = [];

  // top actions
  const topActions = [];

  const tableParams = useMemo(() => getTableParams(t), []);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Звонки')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        {...tableParams}
      />

    </GridBox>
  );
};
